// Tile-style US map (50-state grid, Swiss editorial feel).
// Each tile is a state with a NCAA division category attached.
import React, { useState } from "react";

// Grid coordinates (col, row) for a typical "US states tile" layout.
// Each entry: [name, abbr, col, row, div]
// div: D1/D2/D3/NAIA/NJCAA — illustrative representative classification per state
export const US_STATES_TILES = [
  ["Alaska", "AK", 0, 0, "D1"],
  ["Maine", "ME", 10, 0, "D1"],
  ["Vermont", "VT", 9, 1, "D1"],
  ["New Hampshire", "NH", 10, 1, "D1"],
  ["Washington", "WA", 1, 1, "D1"],
  ["Idaho", "ID", 2, 1, "D1"],
  ["Montana", "MT", 3, 1, "D1"],
  ["North Dakota", "ND", 4, 1, "D1"],
  ["Minnesota", "MN", 5, 1, "D1"],
  ["Wisconsin", "WI", 6, 1, "D1"],
  ["Michigan", "MI", 7, 1, "D1"],
  ["New York", "NY", 9, 2, "D1"],
  ["Massachusetts", "MA", 10, 2, "D1"],
  ["Oregon", "OR", 1, 2, "D1"],
  ["Utah", "UT", 2, 2, "D1"],
  ["Wyoming", "WY", 3, 2, "D1"],
  ["South Dakota", "SD", 4, 2, "NAIA"],
  ["Iowa", "IA", 5, 2, "D1"],
  ["Illinois", "IL", 6, 2, "D1"],
  ["Indiana", "IN", 7, 2, "D1"],
  ["Ohio", "OH", 8, 2, "D1"],
  ["Pennsylvania", "PA", 9, 3, "D1"],
  ["New Jersey", "NJ", 10, 3, "D1"],
  ["Connecticut", "CT", 11, 2, "D1"],
  ["Rhode Island", "RI", 11, 3, "D1"],
  ["California", "CA", 1, 3, "D1"],
  ["Nevada", "NV", 2, 3, "D1"],
  ["Colorado", "CO", 3, 3, "D1"],
  ["Nebraska", "NE", 4, 3, "D1"],
  ["Missouri", "MO", 5, 3, "D1"],
  ["Kentucky", "KY", 6, 3, "D1"],
  ["West Virginia", "WV", 7, 3, "D1"],
  ["Virginia", "VA", 8, 3, "D1"],
  ["Maryland", "MD", 9, 4, "D1"],
  ["Delaware", "DE", 10, 4, "D1"],
  ["Arizona", "AZ", 2, 4, "D1"],
  ["New Mexico", "NM", 3, 4, "D1"],
  ["Kansas", "KS", 4, 4, "D1"],
  ["Arkansas", "AR", 5, 4, "D1"],
  ["Tennessee", "TN", 6, 4, "D1"],
  ["North Carolina", "NC", 7, 4, "D1"],
  ["South Carolina", "SC", 8, 4, "D1"],
  ["Oklahoma", "OK", 4, 5, "D1"],
  ["Louisiana", "LA", 5, 5, "D1"],
  ["Mississippi", "MS", 6, 5, "D1"],
  ["Alabama", "AL", 7, 5, "D1"],
  ["Georgia", "GA", 8, 5, "D1"],
  ["Hawaii", "HI", 0, 6, "D1"],
  ["Texas", "TX", 4, 6, "D1"],
  ["Florida", "FL", 9, 6, "D1"],
];

// Representative universities per state (small, illustrative set)
export const STATE_UNIVERSITIES = {
  CA: [
    { name: "Stanford University", div: "NCAA Division I" },
    { name: "UCLA", div: "NCAA Division I" },
    { name: "UC San Diego", div: "NCAA Division I" },
    { name: "Pomona-Pitzer", div: "NCAA Division III" },
  ],
  TX: [
    { name: "University of Texas at Austin", div: "NCAA Division I" },
    { name: "Texas A&M", div: "NCAA Division I" },
    { name: "Rice University", div: "NCAA Division I" },
  ],
  FL: [
    { name: "University of Florida", div: "NCAA Division I" },
    { name: "University of Miami", div: "NCAA Division I" },
    { name: "Florida State University", div: "NCAA Division I" },
  ],
  NY: [
    { name: "Columbia University", div: "NCAA Division I" },
    { name: "Cornell University", div: "NCAA Division I" },
    { name: "NYU", div: "NCAA Division III" },
  ],
  MA: [
    { name: "Harvard University", div: "NCAA Division I" },
    { name: "MIT", div: "NCAA Division III" },
    { name: "Boston College", div: "NCAA Division I" },
  ],
  NC: [
    { name: "Duke University", div: "NCAA Division I" },
    { name: "University of North Carolina", div: "NCAA Division I" },
  ],
  PA: [
    { name: "University of Pennsylvania", div: "NCAA Division I" },
    { name: "Penn State University", div: "NCAA Division I" },
  ],
  IL: [
    { name: "Northwestern University", div: "NCAA Division I" },
    { name: "University of Illinois", div: "NCAA Division I" },
    { name: "University of Chicago", div: "NCAA Division III" },
  ],
  CT: [{ name: "Yale University", div: "NCAA Division I" }],
  NJ: [{ name: "Princeton University", div: "NCAA Division I" }],
  MI: [
    { name: "University of Michigan", div: "NCAA Division I" },
    { name: "Michigan State University", div: "NCAA Division I" },
  ],
  OH: [{ name: "Ohio State University", div: "NCAA Division I" }],
  IN: [{ name: "University of Notre Dame", div: "NCAA Division I" }],
  GA: [{ name: "Emory University", div: "NCAA Division III" }, { name: "Georgia Tech", div: "NCAA Division I" }],
  VA: [{ name: "University of Virginia", div: "NCAA Division I" }],
  CO: [{ name: "University of Colorado Boulder", div: "NCAA Division I" }],
  AZ: [{ name: "Arizona State University", div: "NCAA Division I" }],
  OR: [{ name: "University of Oregon", div: "NCAA Division I" }],
  WA: [{ name: "University of Washington", div: "NCAA Division I" }],
  TN: [{ name: "Vanderbilt University", div: "NCAA Division I" }],
  SC: [{ name: "University of South Carolina", div: "NCAA Division I" }],
  AL: [{ name: "University of Alabama", div: "NCAA Division I" }],
  LA: [{ name: "LSU", div: "NCAA Division I" }, { name: "Tulane", div: "NCAA Division I" }],
  KY: [{ name: "University of Kentucky", div: "NCAA Division I" }],
  WI: [{ name: "University of Wisconsin-Madison", div: "NCAA Division I" }],
  MN: [{ name: "University of Minnesota", div: "NCAA Division I" }],
  IA: [{ name: "University of Iowa", div: "NCAA Division I" }],
  MO: [{ name: "Washington University in St. Louis", div: "NCAA Division III" }],
  NV: [{ name: "UNLV", div: "NCAA Division I" }],
  UT: [{ name: "BYU", div: "NCAA Division I" }, { name: "University of Utah", div: "NCAA Division I" }],
  KS: [{ name: "University of Kansas", div: "NCAA Division I" }],
  NE: [{ name: "University of Nebraska", div: "NCAA Division I" }],
  ID: [{ name: "Boise State University", div: "NCAA Division I" }],
  HI: [{ name: "University of Hawaii", div: "NCAA Division I" }],
  OK: [{ name: "University of Oklahoma", div: "NCAA Division I" }],
  AR: [{ name: "University of Arkansas", div: "NCAA Division I" }],
  MS: [{ name: "Ole Miss", div: "NCAA Division I" }],
  NM: [{ name: "University of New Mexico", div: "NCAA Division I" }],
  WY: [{ name: "University of Wyoming", div: "NCAA Division I" }],
  ND: [{ name: "North Dakota State", div: "NCAA Division I" }],
  SD: [{ name: "Dakota Wesleyan", div: "NAIA" }],
  ME: [{ name: "University of Maine", div: "NCAA Division I" }],
  VT: [{ name: "University of Vermont", div: "NCAA Division I" }],
  NH: [{ name: "Dartmouth College", div: "NCAA Division I" }],
  RI: [{ name: "Brown University", div: "NCAA Division I" }],
  DE: [{ name: "University of Delaware", div: "NCAA Division I" }],
  MD: [{ name: "Johns Hopkins University", div: "NCAA Division III" }, { name: "University of Maryland", div: "NCAA Division I" }],
  WV: [{ name: "West Virginia University", div: "NCAA Division I" }],
  AK: [{ name: "University of Alaska Anchorage", div: "NCAA Division II" }],
  MT: [{ name: "University of Montana", div: "NCAA Division I" }],
};

const DIV_MAP = {
  D1: "NCAA Division I",
  D2: "NCAA Division II",
  D3: "NCAA Division III",
  NAIA: "NAIA",
  NJCAA: "NJCAA",
};

const COLS = 12;
const ROWS = 7;
const CELL = 56;
const GAP = 6;
const WIDTH = COLS * CELL + (COLS - 1) * GAP;
const HEIGHT = ROWS * CELL + (ROWS - 1) * GAP;

const LABEL_STYLE = {
  fontSize: 13,
  fontFamily: "Cinzel, serif",
  letterSpacing: 1,
  fontWeight: 600,
  pointerEvents: "none",
};

const matchesDivision = (div, filterDiv) => !filterDiv || filterDiv === "all" || DIV_MAP[div] === filterDiv;

const tileFill = ({ isSelected, isHover, enabled }) => {
  if (isSelected) return "#C4A46A";
  if (!enabled) return "#3a3f49";
  return isHover ? "#1B2E4D" : "#0F1B2D";
};

const StateTile = ({ abbr, col, row, enabled, isHover, isSelected, onHover, onSelect }) => {
  const x = col * (CELL + GAP);
  const y = row * (CELL + GAP);
  return (
    <g
      data-testid={`map-state-${abbr}`}
      onMouseEnter={() => onHover(abbr)}
      onMouseLeave={() => onHover(null)}
      onClick={() => enabled && onSelect?.(abbr)}
      style={{ cursor: enabled ? "pointer" : "not-allowed" }}
    >
      <rect x={x} y={y} width={CELL} height={CELL} fill={tileFill({ isSelected, isHover, enabled })} stroke={isSelected ? "#C4A46A" : "#1f2a3d"} strokeWidth="1" />
      <text x={x + CELL / 2} y={y + CELL / 2 + 4} textAnchor="middle" style={{ ...LABEL_STYLE, fill: isSelected ? "#0F1B2D" : "#F4F0E8" }}>
        {abbr}
      </text>
      {isSelected && <circle cx={x + CELL - 8} cy={y + 8} r="3" fill="#0F1B2D" />}
    </g>
  );
};

const USMap = ({ selected, onSelect, filterDiv }) => {
  const [hover, setHover] = useState(null);
  return (
    <div className="w-full overflow-x-auto" data-testid="us-map">
      <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`} width="100%" style={{ maxWidth: "100%", height: "auto" }} role="img" aria-label="United States — interactive tile map">
        {US_STATES_TILES.map(([, abbr, col, row, div]) => (
          <StateTile
            key={abbr}
            abbr={abbr}
            col={col}
            row={row}
            enabled={matchesDivision(div, filterDiv)}
            isHover={hover === abbr}
            isSelected={selected === abbr}
            onHover={setHover}
            onSelect={onSelect}
          />
        ))}
      </svg>
      {hover && (
        <div className="mt-3 text-sm text-[#5E6470]" data-testid="map-hover-name">
          {US_STATES_TILES.find((s) => s[1] === hover)?.[0]}
        </div>
      )}
    </div>
  );
};

export default USMap;
